<template>
    <v-card class="ma-3 pa-5">
        <v-card-title>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="soilTypes" :items-per-page="20" class="elevation-1" :search="search">
            <template v-slot:item.edit="{ item }">
                <v-btn icon color="primary" :to="{ name: 'soil-type-view', params: { id: item.id } }">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'SoilTypeListTable',
    data() {
        return {
            search: '',
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'kp',
                    align: 'end',
                    sortable: false,
                    value: 'kp',
                },
                {
                    text: 'Erw',
                    align: 'end',
                    sortable: false,
                    value: 'Erw',
                },
                {
                    text: 'Erj0',
                    align: 'end',
                    sortable: false,
                    value: 'Erj0',
                },
                {
                    text: 'sp',
                    align: 'end',
                    sortable: false,
                    value: 'sp',
                },
                {
                    text: 'fc',
                    align: 'end',
                    sortable: false,
                    value: 'fc',
                },
                {
                    text: 'wp',
                    align: 'end',
                    sortable: false,
                    value: 'wp',
                },
                {
                    text: 'ssp',
                    align: 'end',
                    sortable: false,
                    value: 'ssp',
                },
                {
                    text: '',
                    align: 'end',
                    sortable: false,
                    value: 'edit',
                },
            ],
        }
    },
    computed: {
        ...mapState('soil', ['soilTypes']),
    },
    async mounted() {
        await this.fetchSoilTypesList()
    },
    methods: {
        ...mapActions('soil', ['fetchSoilTypesList']),
    },
}
</script>

<style scoped></style>
